import React from "react";
import { CheckCircle2, Clock, AlertTriangle, CircleDashed } from "lucide-react";
import { useT } from "@/lib/i18n";

const MAP: Record<string, { cls: string; key: any; Icon: any }> = {
  paid: { cls: "bg-green-50 text-green-700 border-green-200", key: "st_paid", Icon: CheckCircle2 },
  partial: { cls: "bg-amber-50 text-amber-800 border-amber-200", key: "st_partial", Icon: CircleDashed },
  pending: { cls: "bg-amber-50 text-amber-800 border-amber-200", key: "st_pending", Icon: Clock },
  overdue: { cls: "bg-rose-50 text-rose-700 border-rose-200", key: "st_overdue", Icon: AlertTriangle },
};

export function StatusPill({ status, testId }: { status: string; testId?: string }) {
  const { t } = useT();
  const s = MAP[status] || MAP.pending;
  return (
    <span data-testid={testId || `status-pill-${status}`} className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${s.cls}`}>
      <s.Icon className="h-3.5 w-3.5" />
      {t(s.key)}
    </span>
  );
}

export const statusBar: Record<string, string> = {
  paid: "bg-green-500", partial: "bg-amber-500", pending: "bg-amber-400", overdue: "bg-rose-600",
};
